import { ICommandStatus } from '@cqrs/cqrs';
import { DownloadProjectTemplateCommandV1 } from '@Projects/Domain/commands-core';
import ProjectCommands from "@Projects/Domain/commands-vue-component";
import ProjectQueries from "@Projects/Domain/queries-vue-component";
import { ProjectTemplateDownloadPageReadModel } from '@Projects/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component
export default class ProjectTemplateDownloadPage extends mixins(ProjectQueries, ProjectCommands)
{
    get accessKey() : string { return this.$route?.params?.accessKey ?? ''; }

    rm: ProjectTemplateDownloadPageReadModel = null;
    IsDownloading: boolean = false;


    handleDownloadProjectTemplateCommand(workspaceId: number)
    {
        this.IsDownloading = true;

        this.invokeDownloadProjectTemplateCommandV1(workspaceId, this.rm.ProjectId, this.rm.ProjectTemplateLinkId);
    }

    mounted()
    {
        document.title = "Download a template | TransparentChoice";
        this.runProjectTemplateDownloadPageQueryV1(this.accessKey);
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName == "ProjectTemplateDownloadPageReadModel")
        {
            this.rm = model as ProjectTemplateDownloadPageReadModel;
        }
    }

    onCommandSucceed(cmd: any, correlationId: string, result: any)
    {
        if (DownloadProjectTemplateCommandV1.matchType(cmd))
        {
            const projectId = parseInt(result);
            location.href = `/#/project/${projectId}`
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (DownloadProjectTemplateCommandV1.matchType(status.Command))
        {
            this.IsDownloading = false;
            alert(status.ValidationErrors[0].Error);
        }
    }

}